"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExternalProvidersPascal = exports.defaultExternalProviders = void 0;
exports.defaultExternalProviders = {
    okay: {
        tracker: {
            eventDataSources: [{
                    event: 'test',
                }],
        },
    },
};
exports.defaultExternalProvidersPascal = {
    Facebook: {
        FacebookPixels: [
            {
                event: "track",
                action: "Search",
                eventJson: "{\"content_type\":\"home_listing\",\"content_ids\":[\"111121-S\",\"63824-S\",\"49496-S\",\"76390-S\",\"158592-S\",\"20821-S\",\"353071-S\",\"368129-S\",\"17315-S\",\"326679-S\",\"65217-S\",\"401669-S\",\"75141-S\",\"16447-S\",\"25760-S\",\"58113-S\",\"405406-S\",\"286059-S\",\"31281-S\",\"385598-S\",\"321578-S\",\"361576-S\",\"312483-S\",\"293432-S\"],\"search_string\":\"\",\"city\":\"Hong Kong\",\"region\":\"Hong Kong\",\"country\":\"Hong Kong\"}"
            }
        ],
    },
    Google: {
        TagManager: {
            Datalayers: [
                {
                    Name: 'event',
                    Value: 'New_Web_Lead',
                },
                {
                    Name: 'eventSrc',
                    Value: 'Contact_agent_form',
                },
                {
                    Name: 'agentid',
                    Value: '123',
                },
                {
                    Name: 'hasdesc',
                    Value: 'True',
                },
                {
                    Name: 'photoscount',
                    Value: '33',
                },
                {
                    Name: 'districtname',
                    Value: 'Discovery Bay',
                },
                {
                    Name: 'gtm',
                    Value: '{"start":"starttest","elementId":"testeid"}',
                },
            ],
        },
        analytics: {
            commands: [
                {
                    method: 'send',
                    nameValues: [{ name: 'hitType', value: 'pageView' }],
                },
                {
                    method: 'send',
                    nameValues: [
                        { name: 'hitType', value: 'pageView' },
                        { name: 'eventCategory', value: 'test' },
                        { name: 'eventAction', value: 'action' },
                        { name: 'eventLabel', value: '123' },
                    ],
                },
            ],
        },
    },
    Okay: {
        Tracker: {
            EventDataSources: [
                {
                    Event: 'track',
                    Source: 'emailid',
                    Data: 'c6178f63-7c9f-45ec-b575-93bac03f619e',
                },
                {
                    Event: 'track',
                    Source: 'ruid',
                    Data: '9842717d-e03d-4e04-8909-32d0d15402b2',
                },
            ],
        },
    },
};
